// extracted by mini-css-extract-plugin
module.exports = {"root":"AnnouncementFormModal-root-ffc42c4eaab57d471566805f1e8f6efa","title":"AnnouncementFormModal-title-15070acc4b5357b6121fa82a424082ca"};